import {
     AfterViewInit,
     Component,
     Inject,
     OnDestroy,
     OnInit,
} from '@angular/core';
import { ITask } from '../planning/planning.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
     IWsPlanningBrowsePlanningItemRes,
     IWsPlanningUserBooking,
} from '../../services/ws/ws.typings';
import { WsService } from '../../services/ws/ws.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../../services/data.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { BookingErrorHandlerService } from '../../services/booking-error-handler.service';
import { TV_SCREEN } from '../../constants';

@Component({
     selector: 'app-book',
     templateUrl: './book.component.html',
     styleUrls: ['./book.component.scss'],
})
export class BookComponent implements OnInit, AfterViewInit, OnDestroy {
     isTvScreen = TV_SCREEN;
     scheduledTask: IWsPlanningBrowsePlanningItemRes;
     taskStarted = false;
     taskFinished = false;
     isBooked = false;
     task: ITask;
     places: number;
     numberOfPlaces: number[];
     maxNumberOfPlaces = 1;
     userBookings$: Subscription;
     userBookingIdPlanningList: number[] = [];

     constructor(
          private dialogRef: MatDialogRef<any>,
          private ws: WsService,
          private dataService: DataService,
          private toastrService: ToastrService,
          @Inject(MAT_DIALOG_DATA)
          public data: {
               scheduledTask: IWsPlanningBrowsePlanningItemRes;
               task: ITask;
          },
          public bookingErrorHandler: BookingErrorHandlerService
     ) {
          this.scheduledTask = data.scheduledTask;
          this.taskFinished = moment().isAfter(data.scheduledTask.end);
          this.taskStarted =
               this.taskFinished || moment().isAfter(data.scheduledTask.start);
          this.task = data.task;
          this.maxNumberOfPlaces =
               (this.task && this.task.maxBookablePlaces) || 1;
     }

     ngOnInit() {
          this.numberOfPlaces = [];
          if (!TV_SCREEN) {
               this.userBookings$ = this.dataService.userBooking$.subscribe(
                    (data: IWsPlanningUserBooking[]) => {
                         this.userBookingIdPlanningList = data.map(
                              (d) => d.idPlanning
                         );
                         this.isBooked =
                              this.userBookingIdPlanningList.indexOf(
                                   this.scheduledTask.id
                              ) >= 0;
                    }
               );
          }
          const arr = [];
          for (let i = 0; i < this.maxNumberOfPlaces; i++) {
               arr.push(i + 1);
          }
          this.numberOfPlaces = arr;
     }

     ngAfterViewInit() {}

     book() {
          if (!TV_SCREEN) {
               this.ws.planning
                    .book(this.scheduledTask.id, this.places)
                    .then(async (data) => {
                         this.toastrService.show(
                              window.appLang.RESERVATION_SUCCESSFULLY_REGISTERED
                         );
                         const userBookings = await this.ws.planning.userBookingList();
                         this.dataService.userBooking$ = userBookings as any;
                         this.closeDialog(data);
                    })
                    .catch((err) => {
                         this.bookingErrorHandler.run(err.error.ctxCode);
                    });
          }
     }

     closeDialog(data?) {
          this.dialogRef.close(data);
     }

     ngOnDestroy() {
          if (this.userBookings$ && this.userBookings$.unsubscribe) {
               this.userBookings$.unsubscribe();
          }
     }
}
